<template>
<!--  <div>
    <div class="footer">
      <div class="wrap">
        <div class="copyright">
          <span>主办: 湘潭市财政局</span>
          <span>技术支持: 湖南云擎科技有限公司</span>
          <span>客服电话: 0731-58552803</span>
          <span>
          <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank">
            闽ICP备2021011660号
          </a>
          </span>
        </div>
      </div>
    </div>
  </div>-->
  <div class="footer">
    <pre>主办: 湘潭市财政局    技术支持: 湖南云擎科技有限公司     客服电话: 0731-58552803    闽ICP备2021011660号</pre>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {

    };
  },
  mounted() {

  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  /*overflow: hidden;
  color: #88899A;
  font-size: 14px;
  background-color: #030F26;
  margin-top: 20px;
  */
  height: 115px;
  background-color: #000f28;
  color: #fff;
  text-align: center;
  line-height: 115px;

  a,
  a:link,
  a:visited,
  a:hover,
  a:active {
    color: #777;
  }

  .copyright {
    padding-top: 30px;
    padding-bottom: 30px;
    width: 100%;
    text-align: center;
    height: 30px;
    line-height: 30px;
    /*border-top: 1px solid #484848;*/
    span {
      margin: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue